import type { RemoteFileSystem } from "@pdfking/storages"
import { BrowserFileSystem } from "@pdfking/storages/browser"

import { ImplementStoreUrl } from "../../internal/ImplementStoreUrl"
import { FILE_STORE_PROTOCOL } from "../../internal/Protocols"

// The filesystem for this platform. `@pdfking/storages` names each
// implementation for what it actually is; these files name the role, so code
// that just wants "the file store" resolves to the right one per build — here
// Cache storage, under a cache of that name.
//
// Which is what its entries are named by: `fs://{name}/{path}` is this store
// on whichever platform reads it.
export const FileStore = (name: string): RemoteFileSystem =>
  ImplementStoreUrl(FILE_STORE_PROTOCOL, name, BrowserFileSystem(name))
